import { useState, useEffect, useRef } from 'react';

/**
 * A custom hook that manages the state of a form package based on the provided stripe subscriptions.
 *
 * @param {Array} stripeSubs - An array of stripe subscriptions.
 * @returns {Array} The current form package based on the matching subscriptions.
 */

export function useFormPackage(stripeSubs, Forms) {
	const [formPackage, setFormPackage] = useState([]);
	const previousPackageRef = useRef([]);

	useEffect(() => {
		console.log('🔄 HOOK: useFormPackage useEffect triggered', {
			stripeSubs: stripeSubs,
			isArray: Array.isArray(stripeSubs),
			currentPackageLength: formPackage.length,
		});
		// Guard against undefined or non-array stripeSubs
		if (!stripeSubs || !Array.isArray(stripeSubs)) {
			console.log('⚠️ HOOK: useFormPackage - stripeSubs not ready');
			// Only reset if formPackage is not already empty
			if (formPackage.length > 0) {
				console.log('🔄 HOOK: useFormPackage - resetting package to empty');
				setFormPackage([]);
				previousPackageRef.current = [];
			}
			return;
		}

		// Find the matching package
		let newFormPackage = [];
		for (const pkg of Forms.packages) {
			// Check if the user has any of the trigger subscriptions for the current package
			const hasSubscription = pkg.triggerSubscriptions.some((subName) =>
				stripeSubs.some((s) => s.productName?.includes(subName))
			);
			// If the user has a matching subscription
			if (hasSubscription) {
				newFormPackage = pkg.forms;
				break;
			}
		}

		// Only update if the package actually changed
		// Compare by length and content to avoid unnecessary re-renders
		const packageChanged =
			previousPackageRef.current.length !== newFormPackage.length ||
			!previousPackageRef.current.every(
				(form, index) => form.id === newFormPackage[index]?.id
			);

		if (packageChanged) {
			console.log('✅ HOOK: useFormPackage - package changed, updating', {
				oldLength: previousPackageRef.current.length,
				newLength: newFormPackage.length,
				newPackage: newFormPackage,
			});
			setFormPackage(newFormPackage);
			previousPackageRef.current = newFormPackage;
		} else {
			console.log(
				'⏭️ HOOK: useFormPackage - package unchanged, skipping update'
			);
		}
	}, [stripeSubs]); // Only depend on stripeSubs to avoid infinite loops

	return formPackage;
}
